/**
 * Semantic styles for the SPEI confirmation variant (Figma two-card layout).
 *
 * A left "SPEI" card (plan, amount, method, note, bank/CLABE pair, closing copy)
 * sits beside a right "Pasos a seguir" card. They stack on small screens
 * (`flex-col`) and, from `lg`, lay out as a wrapping row: both cards `grow`, but the
 * right card's far larger grow factor (`lg:grow-[999]`) keeps the left at ~600px and
 * lets the right fill the rest while honoring a 400px minimum (`lg:min-w-[400px]`);
 * once they no longer fit, the right card wraps below and each card spans full width.
 * The CLABE box and steps card center their content vertically. `root` uses
 * `my-auto` (not `justify-center`) so the screen centers when short but scrolls from
 * the top once the cards grow tall.
 */
export const speiConfirmationStyles = {
  root: 'my-auto flex w-full flex-col items-center gap-6 p-6 font-sans',
  content: 'flex w-full max-w-[1064px] flex-col gap-6',
  header: 'justify-center lg:justify-start',
  cards: 'flex flex-col gap-4 lg:flex-row lg:flex-wrap lg:items-stretch',
  speiCard: 'flex w-full flex-col gap-6 p-6 shadow-xs lg:grow lg:basis-[600px]',
  speiHeader: 'flex flex-col gap-1',
  planName: 'text-base font-medium text-foreground',
  amountRow: 'flex flex-wrap items-center gap-1',
  amount: 'text-3xl font-bold text-foreground',
  methodRow: 'flex items-center gap-1',
  methodLabel: 'text-base font-semibold text-foreground',
  note: 'text-sm text-foreground',
  clabeRow: 'flex flex-col gap-3 sm:flex-row sm:items-stretch',
  bankBox:
    'flex w-full flex-col gap-2 rounded-lg border border-border p-3.5 text-xs leading-3 sm:w-[213px] sm:shrink-0',
  bankRow: 'flex gap-1',
  bankKey: 'text-muted-foreground',
  bankValue: 'font-semibold text-foreground',
  clabe: 'flex w-full flex-1 flex-col justify-center md:w-auto',
  closingBox: 'flex w-full flex-col',
  closingTitle: 'text-sm font-semibold text-foreground',
  closingDescription: 'text-sm text-foreground',
  stepsCard: 'flex w-full flex-col justify-center gap-5 p-6 shadow-xs lg:min-w-[400px] lg:grow-[999] lg:basis-[400px]',
  stepsTitle: 'text-base font-semibold text-foreground',
  stepsList: 'ml-4 flex list-decimal flex-col gap-2 text-sm text-muted-foreground',
  button: 'self-end',
};
